import React from 'react';

const OurSuccessStories: React.FC = () => (
  <div className="static-page">
    <h1>Our Success Stories</h1>
    <p>Read about our clients' successful immigration journeys and how our team helped them achieve their goals. Visit our blog for detailed case studies and testimonials.</p>
  </div>
);

export default OurSuccessStories;
